import { AxiosError } from "axios";
import customAxios from "config";

export const getInvoice = async (
  payload: any
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/bookings/tentative_booking_invoice/",
      payload
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        error:
          error.response?.data?.detail ||
          error.response?.data?.error ||
          "An error occurred during fetching invoince.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

// Per-cycle price projection for multi-week / multi-month LTR bookings
// (1NOW-1095). Same payload shape as `getInvoice`, but returns an array of
// projected invoices — one per cycle — so the storefront can show each
// upcoming week's total BEFORE the customer confirms the booking. Returns
// an empty array when the company / payload isn't a multi-cycle LTR.
export const getLongTermWeeklyQuote = async (
  payload: any
): Promise<{ data?: any[]; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/bookings/long-term-weekly-quote/",
      payload
    );
    return { data: Array.isArray(response.data) ? response.data : [] };
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        error:
          error.response?.data?.detail ||
          error.response?.data?.error ||
          "An error occurred while fetching the per-week price breakdown.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};
